var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from 'react';
import { get } from '../../../../api/request';
import axios from 'axios';
export var useJwtToken = function (_a) {
    var _b = _a.withoutLoginRedirect, withoutLoginRedirect = _b === void 0 ? false : _b, _c = _a.showError, showError = _c === void 0 ? true : _c, _d = _a.jwt, jwt = _d === void 0 ? null : _d, _e = _a.skip, skip = _e === void 0 ? false : _e;
    var _f = __read(useState(), 2), accessToken = _f[0], setAccessToken = _f[1];
    useEffect(function () {
        if (!skip) {
            if (jwt) {
                axios.defaults.headers['Authorization'] = "Bearer " + jwt;
                setAccessToken(jwt);
                return;
            }
            get('/accounts/jwt/', { showError: showError }, { withoutLoginRedirect: withoutLoginRedirect }).then(function (_a) {
                var accessToken = _a.accessToken;
                return setAccessToken(accessToken);
            });
        }
    }, [showError, withoutLoginRedirect, jwt, skip]);
    return {
        accessToken: accessToken,
    };
};
//# sourceMappingURL=useJwtToken.js.map